"use client";
import { initClientContext } from "@app/services/clientContext";
import { COLORS } from "@ea/ui/styles/ThemeRegistry/colors";
import { ThemeRegistry } from "@ea/ui/styles/ThemeRegistry/ThemeRegistry";
import { AppRouterCacheProvider } from "@mui/material-nextjs/v16-appRouter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import dynamic from "next/dynamic";
import React, { useState } from "react";
import { Toaster } from "react-hot-toast";
import { FeaturesProvider } from "../../components/common/FeaturesProvider";
import { BrandProvider } from "@ea/ui/contexts/BrandContext";
import { ApplicationVariant } from "@ea/shared_types/next/ea.enums";

const NextTopLoader = dynamic(() => import("nextjs-toploader"), { ssr: false });

type ProvidersProps = {
  children: React.ReactNode;
  appVariant?: ApplicationVariant;
};

initClientContext();
export const Providers = ({ children, appVariant }: ProvidersProps) => {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <AppRouterCacheProvider options={{ key: "mui" }}>
      <BrandProvider appVariant={appVariant}>
        <ThemeRegistry>
          <QueryClientProvider client={queryClient}>
            <NextTopLoader showSpinner={false} height={4} />
            <Toaster
              toastOptions={{
                style: {
                  color: "white",
                  backgroundColor: COLORS.NEUTRAL[900],
                  borderRadius: "8px",
                },
              }}
              position="bottom-left"
            />
            <FeaturesProvider>{children}</FeaturesProvider>
          </QueryClientProvider>
        </ThemeRegistry>
      </BrandProvider>
    </AppRouterCacheProvider>
  );
};
